export function formatClassificationDisplayValue(
  value: string | null | undefined
): string {
  if (!value) {
    return ''
  }
  return value.replace(/_/g, ' ')
}

export function normalizeClassificationEditableValue(
  value: string
): string | null {
  const trimmed = value.trim()
  if (trimmed.length === 0) {
    return null
  }
  return trimmed
}
